import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { DmsModule } from "../../../dms/dms.module";
import { ModalModule } from "../../../modal/modal.module";
import { TitledInputModule } from "../../../titled-input/titled-input.module";
import { CatalogItemFinderModule } from "../catalog-item-finder/catalog-item-finder.module";
import { CatalogModalComponent } from "./catalog-modal-search.component";

const components = [CatalogModalComponent];

@NgModule({
	declarations: components,
	imports: [CatalogItemFinderModule, IonicModule, ModalModule, TitledInputModule, FormsModule, DmsModule]
})
export class CatalogModalSearchModule {}
